module.exports = __webpack_public_path__ + "static/media/icon-location-s.2dae3f72.svg";